import { FC, ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { Tooltip } from '~/components';
import { InfoIcon } from '~/icons';
import { infoIconStyles } from '../pages/ProjectDetailsPage/components/styles';

interface InfoFormLabelProps {
  label: string;
  tooltipText?: ReactNode;
}

const InfoFormLabel: FC<InfoFormLabelProps> = ({ label, tooltipText }) => (
  <Stack direction="row" alignItems="flex-start" spacing={0.25}>
    <Typography variant="body2">{label}</Typography>
    {tooltipText && (
      <Tooltip title={tooltipText}>
        <InfoIcon style={infoIconStyles} />
      </Tooltip>
    )}
  </Stack>
);

export default InfoFormLabel;
